import {Component} from 'panel';

import {registerMPElement} from 'common/util/register-element';

import template from './index.jade';

class VisibilityControls extends Component<{}> {
  get config() {
    return {
      template,

      helpers: {
        getTooltipText: () => `You need owner permissions to change this setting`,
        handleClickHidden: () => {
          this.dispatchEvent(
            new CustomEvent(`changeHidden`, {
              detail: {
                value: !this.attr(`hidden-value`),
              },
            }),
          );
        },
        handleClickLocked: () => {
          this.dispatchEvent(
            new CustomEvent(`changeLocked`, {
              detail: {
                value: !this.attr(`locked-value`),
              },
            }),
          );
        },
      },
    };
  }

  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'entity-type': `string`,
      'entity-type-plural': `string`,
      'hidden-value': `boolean`,
      'hidden-disabled': `boolean`,
      'locked-value': `boolean`,
      'locked-disabled': `boolean`,
    };
  }
}

export default registerMPElement(`mp-visibility-controls`, VisibilityControls);
